import { isPresent } from '@imcc/utilities';
import { AppActions } from 'app/app-actions.enum';
import { CollectionAction } from '../collection-action.interface';
import { CollectionActions } from '../collection-actions.enum';
import { CollectionState } from '../collection-state.interface';
import { initialState } from './initial-state';
import onError from './on-error';
import onRequest from './on-request';
import onStoreInit from './on-store-init';
import onSuccess from './on-success';

const isRequest = (actionType: string): boolean => [
  CollectionActions.CREATE_REQUEST,
  CollectionActions.UPDATE_REQUEST,
  CollectionActions.UPDATE_LIST_REQUEST,
  CollectionActions.DELETE_REQUEST,
  CollectionActions.ADD_ASSETS_REQUEST,
  CollectionActions.REMOVE_ASSETS_REQUEST,
].some((value) => value === actionType);

const isError = (actionType: string): boolean => [
  CollectionActions.CREATE_ERROR,
  CollectionActions.UPDATE_ERROR,
  CollectionActions.UPDATE_LIST_ERROR,
  CollectionActions.DELETE_ERROR,
].some((value) => value === actionType);

const isSuccess = (actionType: string): boolean => [
  CollectionActions.ADD_ASSETS_SUCCESS,
  CollectionActions.REMOVE_ASSETS_SUCCESS,
  CollectionActions.CHANGE_NAME_SUCCESS,
  CollectionActions.UPDATE_SUCCESS,
  CollectionActions.CREATE_SUCCESS,
  CollectionActions.DELETE_SUCCESS,
  CollectionActions.UPDATE_LIST_SUCCESS,
  AppActions.LOAD_STATE_SUCCESS,
  CollectionActions.SET_AS_DEFAULT,
].some((value) => value === actionType);

const isStoreInit = (actionType: string): boolean => actionType === '@ngrx/store/init';

export function collectionReducer(
  state: CollectionState = initialState,
  action: CollectionAction,
): CollectionState {
  let newState = isPresent(state) ? { ...state } : { ...initialState };

  if (isStoreInit(action.type)) {
    newState = onStoreInit(newState);
  } else if (isRequest(action.type)) {
    newState = onRequest(newState, action);
  } else if (isError(action.type)) {
    newState = onError(newState, action);
  } else if (isSuccess(action.type)) {
    newState = onSuccess(newState, action);
  }

  return newState;
}
